/**
 * DungeonLevel - Data structure for a single dungeon level.
 */
export default class DungeonLevel {
  constructor(levelIndex) {
    this.levelIndex = levelIndex;

    /** @type {number[][]} 2D grid: grid[x][z] = TILE type */
    this.grid = null;

    this.gridWidth = 0;
    this.gridHeight = 0;

    /** @type {Array<{id: number, x: number, z: number, width: number, depth: number, type: string, center: {x: number, z: number}}>} */
    this.rooms = [];

    /** @type {Array<{segments: Array<{x: number, z: number, width: number, depth: number}>}>} */
    this.corridors = [];

    /** @type {Array<{x: number, y: number, z: number, width: number, height: number, depth: number, materials: Object, role: string}>} */
    this.cuboidDefs = [];

    /** @type {Array<{x: number, y: number, z: number, type: string, data?: Object}>} */
    this.spawnPoints = [];

    /** @type {{x: number, y: number, z: number}|null} */
    this.entryPoint = null;

    /** @type {{x: number, y: number, z: number}|null} */
    this.exitPoint = null;

    /** @type {string|null} Theme name for this level */
    this.themeName = null;

    /** @type {Array<Object>|null} Objectives for this level */
    this.objectives = null;

    /** @type {Array<{x, y, z, textureUrl, scale, flipped}>} Vegetation impostor definitions */
    this.vegetationDefs = [];
  }
}
